module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_39.b4cce5d9.png";